import './index.css'
import * as React from 'react'
import { Image, Typography } from 'antd'

const { Text } = Typography

const TableEmpty = () => {
  return (
    <div className='empty_container'>
      <Image preview={false} width='150px' src='/assets/icon/table-empty.png' />
      <Text type='secondary' style={{ fontSize: '12px' }}>
        {'No record buzzing around here.'}
      </Text>
    </div>
  )
}

export default TableEmpty
